import React, { useState } from "react"
import styles from "./contact.module.scss"

function Contact() {
  const [status, setStatus] = useState("")
  const [loading, setLoading] = useState(false)

  const submitForm = (ev) => {
    setLoading(true)
    ev.preventDefault()
    const form = ev.target
    const data = new FormData(form)
    const xhr = new XMLHttpRequest()
    xhr.open(form.method, form.action)
    xhr.setRequestHeader("Accept", "application/json")
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return
      if (xhr.status === 200) {
        form.reset()
        setStatus("SUCCESS")
        setLoading(false)
      } else {
        setStatus("ERROR")
        setLoading(false)
      }
    }
    xhr.send(data)
  }

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <p className={styles.subtitle}>Get in Touch</p>
          <h2 className={styles.title}>
            Let's <span className={styles.gradient}>Connect</span>
          </h2>
          <p className={styles.subtext}>Have a question or want to work together?</p>
        </div>

        <div className={styles.formWrapper}>
          <form
            onSubmit={submitForm}
            action="https://formspree.io/xeqreyae"
            method="POST"
            className={styles.form}
          >
            <div className={styles.inputGroup}>
              <input
                type="text"
                id="name"
                name="name"
                required
                className={styles.input}
                placeholder=" "
              />
              <label htmlFor="name" className={styles.label}>
                Name
              </label>
            </div>

            <div className={styles.inputGroup}>
              <input
                type="email"
                id="email"
                name="email"
                required
                className={styles.input}
                placeholder=" "
              />
              <label htmlFor="email" className={styles.label}>
                Email Address
              </label>
            </div>

            <div className={styles.inputGroup}>
              <textarea
                id="message"
                name="message"
                required
                rows="5"
                className={styles.textarea}
                placeholder=" "
              />
              <label htmlFor="message" className={styles.label}>
                Your Message
              </label>
            </div>

            {status === "SUCCESS" && (
              <p className={styles.successMessage}>
                Thanks for reaching out! I'll get back to you shortly.
              </p>
            )}

            {status === "ERROR" && (
              <p className={styles.errorMessage}>
                Oops! There was an error sending your message. Please try again.
              </p>
            )}

            <button type="submit" disabled={loading} className={styles.submitBtn}>
              {loading ? (
                <div className={styles.spinner} />
              ) : status === "SUCCESS" ? (
                "Message Sent!"
              ) : (
                "Send Message"
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  )
}

export default Contact
